import { openAutoCMSCollectionView } from './openAutoCMS'

export default async ({
  hostname,
  editorSdkProxy,
  collectionName,
  origin,
  wixData,
  collectionsApi,
  i18n,
  logger,
  appApi,
  importRequested,
  experimentsManager,
  sdkVersion,
}) =>
  openAutoCMSCollectionView({
    editorSdkProxy,
    collectionId: collectionName,
    origin,
    wixData,
    collectionsApi,
    hostname,
    i18n,
    logger,
    appApi,
    importRequested,
    experimentsManager,
    sdkVersion,
  })
